// extracted by mini-css-extract-plugin
module.exports = {"rainbow":"About_rainbow__321n8","team":"About_team__J6mgX","hero":"About_hero__l_C0N"};